<template>
    <div class="mx_content">
        <div class="mx_title">
            <div class="title_left">
                <span>结果归档明细</span>
            </div>
            <div class="title_right">
                <el-button v-if="canEdit" size="mini" @click="addMx">新增</el-button>
            </div>
        </div>
        <el-table v-if="updated" :data="listData" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="fileType" label="文件类型" align="center" width="300px" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div v-if="canEdit && !scope.row.isAutoGenerated">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="文件类型" :rules="feeTypeRules">
                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                <el-select v-model="scope.row.fileType" placeholder="请选择文件类型" style="width: 100%">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-tooltip>
                        </ValidationProvider>
                    </div>
                    <div v-else class="file-type">{{ fileTypeFormat(scope.row.fileType) }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="fileName" label="文件上传" align="left" width="300px">
                <template slot-scope="scope">
                    <div v-if="scope.row.passenger.attachments && scope.row.passenger.attachments.length > 0">
                        <div v-for="attach in scope.row.passenger.attachments" class="attachment-link-wrapper">
                            <el-link :title="attach.fileName" class="attachment-link" @click="download(attach)">
                                {{ truncateFileName(attach.fileName) }}
                            </el-link>
                            <span style="color: red" v-if="attach.deleteing">正在删除...</span>
                            <span v-else-if="canEdit" class="remove-button" style="color: red; margin-left: 10px; cursor: pointer" @click="handleRemove(attach, scope.row)">x</span>
                        </div>
                    </div>

                    <div v-if="canEdit" @click="uploadChange(scope.row)" style="width: 100%; text-align: right">
                        <span style="color: red" v-if="scope.row.uploading">正在上传...</span>
                        <ValidationProvider v-else ref="ValidationProvider" v-slot="{ errors }" name="文件上传">
                            <el-upload ref="uploadRef" class="upload-demo" action="#" :on-change="fileChange" :auto-upload="false" :on-remove="handleRemove" :multiple="false" :file-list="scope.row.passenger.attachments" :show-file-list="false">
                                <div style="color: #409eff">上传</div>
                            </el-upload>
                        </ValidationProvider>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="memo" label="备注" align="center">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <el-input v-model="scope.row.memo" v-can-edit :can-edit="canEdit" name="memo" placeholder="请输入备注" />
                    </div>
                    <div v-else>{{ scope.row.memo }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="fileSize" label="文件大小" align="center" width="100px">
                <template slot-scope="scope">
                    <div>{{ scope.row.fileSize }}</div>
                </template>
            </el-table-column>
            <el-table-column v-if="canEdit" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link :style="{ color: scope.row.isAutoGenerated ? '#ccc' : '#409eff' }" type="primary" @click="delClick(scope.row)">删除</el-link>
                    <!-- <span v-else style="color: #ccc;">不可删</span> -->
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
const { uuid, formatFileSize } = require('@/global/utils/index.js')
import moment from 'moment'
export default {
    components: {},
    props: {
        // 通用属性
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        module: { type: String, default: null },
        baseUrl: { type: String, default: null },
        listName: { type: String, default: null },
        isHttp: { type: Boolean, default: true }

        // 自定义属性
    },
    emits: ['validate-fail', 'validate-success'],
    setup() {
        const feeTypeRules = {
            required: true
        }
        const feeDescRules = {
            required: true
        }
        const occureDateRules = {
            required: true
        }

        const feeAmountRules = {
            required: true
        }

        const handleFeeAmountInput = (value) => {
            // 这里可以添加对费用金额的其他校验逻辑
        }

        // 如果需要，可以在这里添加对ValidationProvider实例的引用逻辑
        // 例如：
        // const { validate } = useValidation();
        // ...

        return {
            feeTypeRules,
            feeAmountRules,
            handleFeeAmountInput,
            feeDescRules,
            occureDateRules
            // ... 其他响应式引用
        }
    },
    data() {
        return {
            // 通用变量
            moduleInfo: {},
            loginUser: this.$store.getters.loginUser,
            listData: [],
            // 自定义变量
            countAll: '0.00',
            updated: true,
            uploadId: '', // 当前上传行id
            isAutoGenerated: false, // 标记是否自动生成过数据
            options: [
                // {
                //     value: 1,
                //     label: '工程造价咨询合同'
                // },
                // {
                //     value: 2,
                //     label: '报送资料( 施工合同、施工图纸、签证、变更单等 )'
                // },
                // {
                //     value: 3,
                //     label: '工程量计算底稿'
                // },
                // {
                //     value: 4,
                //     label: '成果文件(工程概况、工作方案或实施方案、质量控制流程表、审核日记、会议纪要、工程资料移交清单、成果文件签收单、工程造价咨询业务质量回访单、盖章版的成果文件扫描件、计价软件版、PDF版、Excel版、xml版'
                // }
                {
                    value: 1,
                    label: '咨询合同（框架协议、子项目合同、中标通知书）'
                },
                {
                    value: 2,
                    label: '送审资料'
                },
                {
                    value: 3,
                    label: '计算底稿'
                },
                {
                    value: 4,
                    label: '成果软件版'
                },
                {
                    value: 5,
                    label: '成果电子版（报告、excel、PDF、xml）'
                },
                {
                    value: 6,
                    label: '成果盖章页'
                },
                {
                    value: 7,
                    label: '完整的盖章版成果文件'
                },
                {
                    value: 8,
                    label: '质量回访单'
                },
                {
                    value: 9,
                    label: '档案归档附件（案卷封面、卷内目录、工作方案、质量控制流程表、审核日记、现场勘查记录表、会议纪要、询价记录表、工程概况及指标分析表、不完整资料催告函、工程资料移交清单、工程资料归还清单、成果文件签收清单）'
                },
                {
                    value: 10,
                    label: '其它'
                }
            ]
        }
    },
    computed: {},
    watch: {
        listData: {
            handler(newVal, oldVal) {
                // 当listData发生变化时，更新vo.passenger[listName]
                this.vo.passenger[this.listName] = newVal
            },
            deep: true
        }
    },
    created() {},
    beforeDestroy() {},
    mounted() {
        this.moduleInfo = {
            delUrl: '/' + this.baseUrl + '/' + this.module + '/delete',
            addNewUrl: '/' + this.baseUrl + '/' + this.module + '/addNew',
            insertUrl: '/' + this.baseUrl + '/' + this.module + '/insert',
            moduleCode: this.module,
            updateUrl: '/' + this.baseUrl + '/' + this.module + '/update',
            listDataUrl: '/' + this.baseUrl + '/' + this.module + '/listdata',
            getByIdUrl: '/' + this.baseUrl + '/' + this.module + '/getById',
            querydata: '/' + this.baseUrl + '/' + this.module + '/querydata'
        }
        this.getListData()
    },
    updated() {},
    methods: {
        autoGenerateDefaultRows() {
            if (this.isAutoGenerated) return
            // const optionsWithoutOther = this.options.filter(item => item.value !== 10)
            this.options.forEach((option) => {
                const row = {
                    id: uuid(),
                    formId: this.vo.id,
                    fileType: option.value,
                    fileName: '',
                    fileSize: '',
                    memo: '',
                    passenger: {
                        attachments: []
                    },
                    creatorId: this.loginUser.id,
                    createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                    isAutoGenerated: true
                }
                this.listData.push(row)
            })
            this.isAutoGenerated = true
        },
        validateBeforeSubmit() {
            const optionsWithoutOther = this.options.filter((item) => item.value !== 10)
            for (let option of optionsWithoutOther) {
                const row = this.listData.find((item) => item.fileType === option.value)
                if (!row || !row.passenger || !row.passenger.attachments || row.passenger.attachments.length === 0) {
                    this.$message.warning(`请上传"${option.label}"文件`)
                    this.$emit('validate-fail', option.label)
                    return false
                }
            }
            this.$emit('validate-success')
            return true
        },
        fileTypeFormat(value) {
            console.log(value, 'value')
            // if (value == 1) {
            //     return '工程造价咨询合同'
            // } else if (value == 2) {
            //     return '报送资料(施工合同、施工图纸、签证、变更单等)'
            // } else if (value == 3) {
            //     return '工程量计算底稿'
            // } else if (value == 4) {
            //     return '成果文件(工程概况、工作方案或实施方案、质量控制流程表、审核日记、会议纪要、工程资料移交清单、成果文件签收单、工程造价咨询业务质量回访单、盖章版的成果文件扫描件、计价软件版、PDF版、Excel版、xml版'
            // }
            return this.options.find((item) => item.value === value)?.label || '未知文件类型'
        },
        uploadChange(row) {
            this.uploadId = row.id
        },
        truncateFileName(fileName) {
            // 这里只是一个简单的示例，你可以根据需要调整逻辑
            const maxLength = 20 // 你可以设置你想要的最大长度
            if (fileName.length > maxLength) {
                return fileName.substring(0, maxLength) + '...'
            }
            return fileName
        },
        fileChange(files, fileList) {
            if (fileList.length > 0) {
                this.uploadAttach([files])

                console.log(files, fileList)
            }
        },
        formatFileRealSize(row) {
            let fileRealSize = 0
            row.passenger.attachments.forEach((attach) => {
                fileRealSize += attach.fileRealSize
            })
            this.$set(row, 'fileSize', formatFileSize(fileRealSize))
        },
        uploadAttach(fileList) {
            const uploadId = this.uploadId
            fileList.forEach((item) => {
                const fd = new FormData()
                fd.append('file', item.raw)
                fd.append('module', this.module)
                fd.append('busiDataId', uploadId)
                fd.append('attachsType', 'ATTACH')
                fd.append('clientType', 'uploader')
                fd.append('attachsName', item.name)

                this.listData.forEach((row) => {
                    if (row.id === uploadId) {
                        this.$set(row, 'uploading', true)
                    }
                })

                this.$http({
                    method: 'post',
                    url: '/' + this.baseUrl + '/' + this.module + '/upload',
                    data: fd
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.listData.forEach((i) => {
                            if (i.id === uploadId) {
                                // 如果attachments数组还不存在，则创建它
                                if (!i.passenger.attachments) {
                                    this.$set(i.passenger, 'attachments', [{}])
                                }
                                i.invoiceId = res.body.invoiceId
                                if (!i.passenger.attachments) {
                                    this.$set(i.passenger, 'attachments', [])
                                }
                                i.passenger.attachments.push(...res.body.uploadAttachList)

                                this.$set(i, 'uploading', false)
                                this.formatFileRealSize(i)
                            }
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })

            console.log(this.listData, 'this.listData')
        },
        handleRemove(file, row) {
            this.$confirm('您是否确认删除附件？', this.$tx('common.confirmOperate', '确认操作'), { type: 'warning' }).then(() => {
                this.$set(file, 'deleteing', true)

                this.$nextTick(() => {
                    this.$http({
                        method: 'delete',
                        url: '/' + this.baseUrl + '/' + this.module + '/deleteAttach',
                        params: {
                            attachIds: file.id
                        }
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.updated = false
                            this.$message.success(res.message)

                            row.passenger.attachments.forEach((attah, index) => {
                                if (attah.id === file.id) {
                                    row.passenger.attachments.splice(index--, 1)
                                }
                            })

                            this.formatFileRealSize(row)

                            this.$nextTick(() => {
                                this.updated = true
                            })
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
            })
        },
        download(attach) {
            if (attach.id === undefined) return
            window.open(process.env.VUE_APP_BASE_API + '/' + this.baseUrl + '/' + this.module + '/downloadById?inline=true&attachIds=' + attach.id)
        },
        getCountAll() {
            let count = 0
            this.listData.forEach((item) => {
                if (item.feeAmount) {
                    count += Number(item.feeAmount)
                }
            })

            this.countAll = count
            this.vo.expenseAmount = this.countAll
            this.vo.payAmount = this.countAll
        },
        async getListData(model) {
            if (this.isHttp) {
                const data = [{ compare: '=', field: 'formId', merge: false, value: this.vo.id }]
                const res = await this.$app.querydata(this.moduleInfo.querydata, data)
                console.log(res, 'getListData')

                if (res.code === 'success') {
                    this.listData = res.body.listdata
                }
            } else if (this.listName) {
                if (this.vo.passenger && this.vo.passenger[this.listName] && this.vo.passenger[this.listName].length > 0) {
                    this.vo.passenger[this.listName].forEach((item) => {
                        if (!item.formId) {
                            item.formId = this.vo.id
                        }
                        if (!item.id) {
                            item.id = uuid()
                        }
                        if (!item.occureDate && item.occurDate) {
                            item.occureDate = item.occurDate
                        }
                        if (!item.creatorId) {
                            item.creatorId = this.loginUser.id
                        }
                        if (!item.createTime) {
                            // 获取当前时间
                            const now = moment()
                            // 格式化当前时间
                            const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
                            item.createTime = formattedNow
                        }
                    })
                    this.listData = this.vo.passenger[this.listName]
                    this.getCountAll()
                }
            } else {
                console.log('请传递listName参数或改用接口获取数据')
            }
            if (this.listData.length === 0) {
                if (this.canEdit && !this.isAutoGenerated) {
                    this.$nextTick(() => {
                        this.autoGenerateDefaultRows()
                    })
                }
            }
            // this.listData前十条数据的isAutoGenerated设置为true
            this.listData.forEach((item, index) => {
                this.formatFileRealSize(item)
                if (index < 10) {
                    item.isAutoGenerated = true
                }
            })
        },
        // 监听input，处理数字
        validateInput(value, scope) {
            console.log(value, scope, 'value')
            value = value.replace(/[^\d.]/g, '') // 只保留数字和小数点
            value = value.replace(/^\./, '') // 去掉开头的小数点
            value = value.replace(/\.{2,}/g, '.') // 去掉多余的小数点
            value = value.replace(/^0+(\d)/, '$1') // 去掉开头的多余零
            value = value.replace(/^(\d+\.\d\d)\d+$/, '$1') // 限制只能输入两位小数
            this.$set(this.listData[scope.$index], scope.column.property, value)
            this.getCountAll()
            console.log(this.listData, 'listData')
        },
        // 删除当前行
        delClick(row) {
            if (row.isAutoGenerated) {
                return
            }
            // 找到要删除的项的索引
            const index = this.listData.findIndex((item) => item.id === row.id)
            if (index !== -1) {
                // 使用splice方法删除该项
                this.listData.splice(index, 1)
                this.getCountAll()
            } else {
                console.error('未找到要删除的数据项')
            }
        },
        addMx() {
            this.$http({
                url: this.moduleInfo.addNewUrl,
                method: 'post'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    res.body.vo.formId = this.vo.id
                    res.body.vo.creatorId = this.loginUser.id

                    // 获取当前时间
                    const now = moment()
                    // 格式化当前时间
                    const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
                    res.body.vo.createTime = formattedNow

                    this.listData.push(res.body.vo)
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.file-type {
    // 超出部分省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/deep/ .el-table .el-link--inner {
    width: 100%;
}

.mx_content /deep/ .el-table__body-wrapper tr td:last-child {
    border-right-color: #e2e7ed !important;
}

.mx_content {
    .mx_title {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #999;
        justify-content: space-between;
        // background: #f2f5fb;
        padding: 0 10px;
    }
}

.attachment-link-wrapper {
    display: flex;
    align-items: center;
    /* 如果需要垂直居中 */
    justify-content: space-between;

    /* 确保链接和按钮之间有间隔，并分别位于开始和结束位置 */
    .el-lint-inner {
        width: 100%;
    }
}

.attachment-link {
    flex: 1;
    /* 占据可用空间，但不会挤压删除按钮 */
    overflow: hidden;
    /* 隐藏超出容器的部分 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    white-space: nowrap;
    /* 防止文本换行 */
    /* 其他你需要的样式 */
}

.remove-button {
    /* 确保按钮始终可见，并位于行尾 */
    /* 你可以添加更多的样式来美化按钮 */
}
</style>
